import { BehaviorSubject } from "rxjs";

export const rxWindowFocus = new BehaviorSubject(true);

document.addEventListener('visibilitychange', (e) => {
    setTimeout(() => {
        rxWindowFocus.next(document.visibilityState === "visible");
    }, 250);
})